module.exports = __webpack_public_path__ + "776d26071d1b6712e133c154aebe8569.svg";